import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChartsModule } from 'ng2-charts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomerComponent } from './petsafe-components/user/customer/customer.component';
import { HelpComponent } from './petsafe-components/help/help.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { SearchResultsComponent } from './petsafe-components/user/search-results/search-results.component';
import { FooterComponent } from './shared-components/footer/footer.component';
import { NavbarComponent } from './shared-components/navbar/navbar.component';
import { ProductActivityChartComponent } from './shared-components/product-activity-chart/product-activity-chart.component';
import { SearchbarComponent } from './shared-components/searchbar/searchbar.component';
import { StatusPanelComponent } from './shared-components/status-panel/status-panel.component';
import { SortByDatePipe } from './pipes/sort-by-date.pipe';
import { SortTimeStampPipe } from './pipes/sort-time-stamp.pipe';
import { HoverCardComponent } from './shared-components/hover-card/hover-card.component';
import { ColorCardComponent } from './shared-components/color-card/color-card.component';
import { SlideInCardComponent } from './shared-components/slide-in-card/slide-in-card.component';
import { JiraTicketSubmittionComponent } from './petsafe-components/jira-ticket-submittion/jira-ticket-submittion.component';
import { ScoopfreeComponent } from './petsafe-components/products/scoopfree/scoopfree.component';
import { ConnectionStatusComponent } from './petsafe-components/products/scoopfree/connection-status/connection-status.component';
import { WifiSignalComponent } from './petsafe-components/products/scoopfree/wifi-signal/wifi-signal.component';
import { RegistrationDateComponent } from './petsafe-components/products/scoopfree/registration-date/registration-date.component';
import { RakeStatusComponent } from './petsafe-components/products/scoopfree/rake-status/rake-status.component';
import { FirmwareComponent } from './petsafe-components/products/scoopfree/firmware/firmware.component';
import { ScoopfreeShadowDetailsComponent } from './petsafe-components/products/scoopfree/scoopfree-shadow-details/scoopfree-shadow-details.component';
import { ScoopfreeActivityFeedComponent } from './petsafe-components/products/scoopfree/scoopfree-activity-feed/scoopfree-activity-feed.component';
import { SmartdoorComponent } from './petsafe-components/products/smartdoor/smartdoor.component';
import { ScheduleComponent } from './petsafe-components/products/smartdoor/schedule/schedule.component';
import { DowPipe } from '@pipe/dow.pipe';
import { SmartdoorShadowDetailsComponent } from './petsafe-components/products/smartdoor/smartdoor-shadow-details/smartdoor-shadow-details.component';
import { SmartfeedComponent } from './petsafe-components/products/smartfeed/smartfeed.component';
import { SmartfeedStatusComponent } from './petsafe-components/products/smartfeed/smartfeed-status/smartfeed-status.component';
import { SmartfeedNameComponent } from './petsafe-components/products/smartfeed/smartfeed-name/smartfeed-name.component';
import { SmartfeedWifiSignalComponent } from './petsafe-components/products/smartfeed/smartfeed-wifi-signal/smartfeed-wifi-signal.component';
import { SmartfeedFoodStatusComponent } from './petsafe-components/products/smartfeed/smartfeed-food-status/smartfeed-food-status.component';
import { SmartfeedRegistrationDateComponent } from './petsafe-components/products/smartfeed/smartfeed-registration-date/smartfeed-registration-date.component';
import { SmartfeedPowerStatusComponent } from './petsafe-components/products/smartfeed/smartfeed-power-status/smartfeed-power-status.component';
import { SmartfeedFirmwareVersionComponent } from './petsafe-components/products/smartfeed/smartfeed-firmware-version/smartfeed-firmware-version.component';
import { SmartfeedLatestMessagesComponent } from './petsafe-components/products/smartfeed/smartfeed-latest-messages/smartfeed-latest-messages.component';
import { SmartfeedSettingsComponent } from './petsafe-components/products/smartfeed/smartfeed-settings/smartfeed-settings.component';
import { SmartfeedScheduledMealsComponent } from './petsafe-components/products/smartfeed/smartfeed-scheduled-meals/smartfeed-scheduled-meals.component';
import { SmartfeedAmazonDashReplenishmentComponent } from './petsafe-components/products/smartfeed/smartfeed-amazon-dash-replenishment/smartfeed-amazon-dash-replenishment.component';
import { UserDetailsComponent } from './petsafe-components/user/user-details/user-details.component';
import { SmartDogTrainerComponent } from './petsafe-components/products/smart-dog-trainer/smart-dog-trainer.component';
import { SmartDogTrainerPreferencesComponent } from './petsafe-components/products/smart-dog-trainer/smart-dog-trainer-preferences/smart-dog-trainer-preferences.component';
import { SdtPrimaryCorrectionPipe } from './pipes/sdt-primary-correction.pipe';
import { SmartdoorActivityFeedComponent } from './petsafe-components/products/smartdoor/smartdoor-activity-feed/smartdoor-activity-feed.component';
import { PetListComponent } from './petsafe-components/pets/pet-list/pet-list.component';
import { ProgressBarComponent } from './shared-components/progress-bar/progress-bar.component';
import { PetProfileComponent } from './petsafe-components/pets/pet-profile/pet-profile.component';
import { SmartdoorActivityPayloadComponent } from './petsafe-components/products/smartdoor/smartdoor-activity-payload/smartdoor-activity-payload.component';
import { PetTagsComponent } from './petsafe-components/pets/pet-tags/pet-tags.component';
import { ClipboardModule } from 'ngx-clipboard';
import { PrettyJsonPipe } from './pipes/pretty-json.pipe';
import { SanitiseHtmlPipe } from './pipes/sanitise-html.pipe';
import { CodeDisplayComponent } from './shared-components/code-display/code-display.component';
import { AppHelpComponent } from './petsafe-components/help/app-help/app-help.component';
import { SmartfeedHelpComponent } from './petsafe-components/help/smartfeed-help/smartfeed-help.component';
import { ScoopfreeHelpComponent } from './petsafe-components/help/scoopfree-help/scoopfree-help.component';
import { SmartdoorHelpComponent } from './petsafe-components/help/smartdoor-help/smartdoor-help.component';
import { SmartDogTrainerHelpComponent } from './petsafe-components/help/smart-dog-trainer-help/smart-dog-trainer-help.component';
import { RouterLink, RouterModule } from '@angular/router';
import { SmartfeedLatestMessagesPayloadComponent } from './petsafe-components/products/smartfeed/smartfeed-latest-messages-payload/smartfeed-latest-messages-payload.component';
import { DecimalToFractionPipe } from '@pipe/decimal-to-fraction.pipe';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    SearchResultsComponent,
    CustomerComponent,
    HelpComponent,
    SearchbarComponent,
    StatusPanelComponent,
    ProductActivityChartComponent,
    SortByDatePipe,
    SortTimeStampPipe,
    HoverCardComponent,
    ColorCardComponent,
    SlideInCardComponent,
    JiraTicketSubmittionComponent,
    ScoopfreeComponent,
    ConnectionStatusComponent,
    WifiSignalComponent,
    RegistrationDateComponent,
    RakeStatusComponent,
    FirmwareComponent,
    ScoopfreeShadowDetailsComponent,
    ScoopfreeActivityFeedComponent,
    SmartdoorComponent,
    ScheduleComponent,
    DowPipe,
    SmartdoorShadowDetailsComponent,
    SmartfeedComponent,
    SmartfeedStatusComponent,
    SmartfeedNameComponent,
    SmartfeedWifiSignalComponent,
    SmartfeedFoodStatusComponent,
    SmartfeedRegistrationDateComponent,
    SmartfeedPowerStatusComponent,
    SmartfeedFirmwareVersionComponent,
    SmartfeedLatestMessagesComponent,
    SmartfeedSettingsComponent,
    SmartfeedScheduledMealsComponent,
    SmartfeedAmazonDashReplenishmentComponent,
    UserDetailsComponent,
    SmartDogTrainerComponent,
    SmartDogTrainerPreferencesComponent,
    SdtPrimaryCorrectionPipe,
    SmartdoorActivityFeedComponent,
    PetListComponent,
    ProgressBarComponent,
    PetProfileComponent,
    SmartdoorActivityPayloadComponent,
    PetTagsComponent,
    PrettyJsonPipe,
    SanitiseHtmlPipe,
    CodeDisplayComponent,
    AppHelpComponent,
    SmartfeedHelpComponent,
    ScoopfreeHelpComponent,
    SmartdoorHelpComponent,
    SmartDogTrainerHelpComponent,
    SmartfeedLatestMessagesPayloadComponent,
    DecimalToFractionPipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    ChartsModule,
    ClipboardModule,
    RouterModule,
  ],
  providers: [HttpClientModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
